export enum RefreshTier {
  Main = 'main',
  Secondary = 'secondary',
  Config = 'config'
}
